import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  Chip,
  DialogActions,
  Button,
} from "@mui/material";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { calculateLengths } from "../../utils/datasetFileUtil";
import { useNavigate } from "react-router-dom";

interface DatasetModalProps {
  open: boolean;
  onClose: () => void;
  dataset: {
    projectId: number | null;
    id: number;
    name: string;
    type: string;
    description: string;
    info: {
      totalFiles: number;
      labeledFiles: number;
    };
    classList: string[];
    count: any[];
    isBlock: boolean; // 프로젝트에 할당된 경우 수정 방지를 위해 true값 넣어 방지
  };
}

export default function DatasetModal({
  open,
  onClose,
  dataset,
}: DatasetModalProps) {
  const navigate = useNavigate();

  const handleEdit = () => {
    navigate(`/datasets/edit/${dataset.id}`);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle variant="h6" fontWeight={700}>
        {dataset.name}
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            p: 1,
          }}
        >
          <Typography>
            <strong>ID:</strong> {dataset.id}
          </Typography>
          <Typography>
            <strong>Type:</strong> {dataset.type}
          </Typography>
          <Typography>
            <strong>Description:</strong> {dataset.description}
          </Typography>
          <Typography>
            <strong>Total Files:</strong> {dataset.info.totalFiles || 0}
          </Typography>

          <Box
            sx={{
              display: "flex",
              gap: 1,
              flexWrap: "wrap",
              alignItems: "center",
            }}
          >
            <Typography>
              <strong>Class List:</strong>
            </Typography>
            {["unlabeled", ...(dataset.classList || [])].map(
              (cls: string, index: number) => {
                const matched = dataset.count?.find(
                  (c: any) => c.label === cls
                );
                const count = matched ? matched.count : 0;

                return (
                  <Chip
                    key={index}
                    label={`${cls} (${count})`}
                    color="primary"
                    variant="outlined"
                  />
                );
              }
            )}
          </Box>
        </Box>
        <Box>
          {dataset.isBlock
            ? `* ${dataset.projectId}번 프로젝트에 할당된 데이터셋으로, 프로젝트 수정에서만 변경 가능합니다.`
            : ""}
        </Box>
      </DialogContent>
      <DialogActions
        sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}
      >
        <Box>
          {dataset.isBlock ? (
            <Button
              onClick={() => {
                navigate(`/project/${dataset.projectId}/setting`);
              }}
              variant="contained"
              color="primary"
            >
              프로젝트 수정으로 이동
            </Button>
          ) : (
            <Button onClick={handleEdit} variant="contained" color="primary">
              수정
            </Button>
          )}

          <Button onClick={onClose} sx={{ mr: 2 }}>
            {t("Close")}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
}
